import useNetwork from './useNetwork';

export default useNetwork;
